/* eslint-disable react/jsx-max-depth */
/* eslint-disable react/no-multi-comp */
/* eslint-disable max-len */
import * as Sentry from "@sentry/react";
import { QueryClient, QueryClientProvider } from "react-query";
import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { ReCaptchaProvider } from "react-recaptcha-x";
import { ReactQueryDevtools } from "react-query/devtools";

import Navigation from "./components/Navigation/Navigation";

import CoursesLayout from "./pages/courses/CoursesLayout";
import Footer from "./components/Footer/Footer";
import Loader from "./components/Loader";
import LoginRoutes from "./pages/login/LoginRoutes";
import MyAccountLayout from "./pages/my-account/MyAccountLayout";

import "./App.scss";
import { AuthProvider } from "./services/wp.auth.service";
import { ClassFilterProvider } from "./pages/calendar/components/ClassFilterProvider";
import { CourseRegistrationProvider } from "./services/CourseRegistrationProvider";
import { FacilitatorGlobalProvider } from "./components/FacilitatorGlobalContext";
import Logout from "./pages/login/Logout";
import { NotifcationsContextProvider } from "./components/NotificationsContext";

import { ProfileCompleteProvider } from "./components/ProfileCompleteContext";
import RequireAuth from "./components/RequireAuth";
import WPPage from "./components/WPPage";

/*
 * These dynamic imports establish code splitting.
 * Webpack will generate one bundle/chunk for each of the
 * staff, practitioner, and respondent sections of the app.
 */
const CalendarLayout = React.lazy(() => import("./pages/calendar/CalendarLayout" /* webpackChunkName: "calendar" */));
const Template = React.lazy(() => import("./pages/template/Template" /* webpackChunkName: "landing" */));
const AdminLayout = React.lazy(() => import("./pages/admin/AdminLayout" /* webpackChunkName: "admin" */));
const FacilitatorLayout = React.lazy(() => import("./pages/facilitators/FacilitatorsLayout" /* webpackChunkName: "facilitators" */));
const RegistrationLayout = React.lazy(() => import("./pages/registration/RegistrationLayout" /* webpackChunkName: "registration" */));

const queryClient = new QueryClient();

/* eslint-disable react/jsx-newline */
const App = () => {

	const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

	return (
		<QueryClientProvider client={queryClient}>
			<ReCaptchaProvider
				langCode="en"
				siteKeyV2={process.env.REACT_APP_RECAPTCHA_KEY}
			>
				<AuthProvider>
					<NotifcationsContextProvider>
						<CourseRegistrationProvider>
							<FacilitatorGlobalProvider>
								<Navigation />

								<Suspense
									fallback={<Loader />}
								>
									<SentryRoutes>
										<Route element={<LoginRoutes />} path="/login/*" />
										<Route element={<CoursesLayout />} path="/class/*" />
										<Route
											element={
												<ProfileCompleteProvider>
													<RequireAuth>
														<MyAccountLayout />
													</RequireAuth>
												</ProfileCompleteProvider>
											} path="/account/*"
										/>
										<Route element={<Template />} path="/template" />
										<Route
											element={
												<ProfileCompleteProvider>
													<RequireAuth allowNonAuth>
														<RegistrationLayout />
													</RequireAuth>
												</ProfileCompleteProvider>
											} path="/registration/*"
										/>
										<Route
											element={
												<RequireAuth requireRole="administrator">
													<AdminLayout />
												</RequireAuth>
											} path="/admin/*"
										/>
										<Route
											element={
												<RequireAuth requireRole="facilitator">
													<FacilitatorLayout />
												</RequireAuth>
											} path="/facilitator/*"
										/>
										<Route
											element={
												<ClassFilterProvider>
													<CalendarLayout />
												</ClassFilterProvider>
											}
											path="/"
										/>
										<Route element={<Logout />} path="/logout" />
										<Route element={<WPPage />} path="/*" />
									</SentryRoutes>
								</Suspense>

								<Footer />
							</FacilitatorGlobalProvider>
						</CourseRegistrationProvider>
					</NotifcationsContextProvider>
				</AuthProvider>
			</ReCaptchaProvider>
			<ReactQueryDevtools initialIsOpen={false} />
		</QueryClientProvider>
	);
};

export default App;
